/**
 * Created by why on 2019/11/7.
 */
/**
 * Created by why on 2019/10/21.
 */
import axios from '@/libs/api.request'
export const query = (serviceName) => {
  return axios.request({
    url: '/setting/query',
    params: {
      serviceName
    },
    method: 'get'
  })
}

export const add = (data) => {
  return axios.request({
    url: '/setting/add',
    data: data,
    method: 'post'
  })
}

export const edit = (data) => {
  return axios.request({
    url: '/setting/edit',
    data: data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/setting-manage.js